import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import PageHeader from "src/Components/Customer/PageHeader";
import SplashScreen from "src/Components/SplashScreen";
import httpRequest from "src/helpers/httpRequest";
import { IPharmacyObj, IqueryParams } from "src/types/GlobalInterfaces";
import { IPaginated } from "src/types/paginated";
import qs from "qs";
import { useSelector } from "react-redux";
import { RootState } from "@store/store";
import PaginationComponet from "src/Components/GlobalComponents/PaginationComponet";
import IsFavoriteComponent from "src/Components/Customer/ProductsAndServicesComponents/IsFavoriteComponent";
import { Link, useLocation } from "react-router-dom";
import AddCartComponent from "src/Components/Customer/ProductsAndServicesComponents/AddCartComponent";
import { truncateString } from "src/helpers/helperFunctions";
import FilterTag from "src/Components/GlobalComponents/FilterTag";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faInfo,
  faInfoCircle,
  faMagnifyingGlass,
  faPlus,
  faXmark,
} from "@fortawesome/free-solid-svg-icons";
import RangeSlider from "src/Components/WebsiteComponents/RangeSlider";
import { CircularProgress } from "@mui/material";
import AddProductPrescribeModal from "src/Components/DoctorComponents/AddProductPrescribeModal";
import BackIcon from "src/assets/images/back-icon.png";
import { CURRENCY } from "src/lib/constans";
import SearchFilterInput from "src/Components/GlobalComponents/SearchFilterInput";
import CustomWebsiteDropdown from "src/Components/GlobalComponents/Widget/CustomWebsiteDropdown";
import PriceFilterDropdown from "src/Components/GlobalComponents/Widget/PriceFilterDropdown";

interface IResponse {
  documents: IPharmacyObj[];
  paginated: IPaginated;
}
const DashboardPharmacyProducts: React.FC = () => {
  const location = useLocation();
  const urlParams = new URLSearchParams(location.search);
  const isPrescribe = urlParams.get("prescribe");
  const appointmentId = urlParams.get("appointmentId");
  const [prescribeProductId, setPrescribeProductId] = useState<null | string>(
    null
  );

  const { userDetails } = useSelector((store: RootState) => store.appReducer);
  const [isLoader, setIsLoader] = useState<boolean>(false);
  const [paginated, setPaginated] = useState<IPaginated>({
    currentPage: 1,
    totalPages: 1,
  }); // Handles pagination state
  const [products, setProducts] = useState<IPharmacyObj[]>([]);
  const [queryParams, setQueryParams] = useState<IqueryParams>({
    page: 1,
    limit: 15,
    userId: userDetails?._id || "",
    mainCategoryId: ["all"],
    brandId: ["all"],
    minPrice: 0,
    maxPrice: 1000000,
    search: "",
  });

  const handleIsLikeChanged = (obj: {
    productId: string;
    isLiked: boolean;
  }) => {
    const { productId = "", isLiked = false } = obj;
    setProducts((prev) =>
      prev?.map((v) => (v._id === productId ? { ...v, isLiked } : v))
    );
  };

  const addAndRemoveById = (key: "mainCategoryId" | "brandId", id: string) => {
    const isExist = queryParams[key]?.includes(id);
    if (isExist) {
      setQueryParams((prev) => ({
        ...prev,
        page: 1,
        [key]: prev[key]?.filter((v: string) => v !== id),
      }));
    } else {
      setQueryParams((prev) => ({
        ...prev,
        page: 1,
        [key]: [...prev[key], id],
      }));
    }
  };

  const fetchProducts = async () => {
    setIsLoader(true);
    const { res, err } = await httpRequest<IResponse>({
      path: `/pharma-inventory/home/getPharmaProducts?${qs.stringify({
        ...queryParams,
        mainCategoryId: queryParams.mainCategoryId
          .map((item: string) => (item === "all" ? "" : item))
          .filter((item: string) => item !== ""),
        brandId: queryParams.brandId
          .map((item: string) => (item === "all" ? "" : item))
          .filter((item: string) => item !== ""),
      })}`,
    });
    if (res) {
      let { documents = [], paginated } = res;
      setProducts(documents);
      setPaginated(paginated);
    } else {
      toast(err, { type: "error" });
    }
    setIsLoader(false);
  };

  const [mainCategoriesStates, setMainCategoriesStates] = useState<{
    loader: boolean;
    searchVal: string;
    isSearch: boolean;
    allMainCategories: { value: string; label: string }[];
  }>({
    loader: false,
    searchVal: "",
    isSearch: false,
    allMainCategories: [],
  });

  const fetchMainCategories = async () => {
    setMainCategoriesStates((prev) => ({ ...prev, loader: true }));
    const { res, err } = await httpRequest<{
      documents: { _id: string; categoryName: string }[];
    }>({ path: `/main-category/getAllMainCategory` });
    if (res) {
      const _data = res?.documents.map((v) => ({
        label: v?.categoryName || "",
        value: v?._id,
      }));
      setMainCategoriesStates((prev) => ({
        ...prev,
        allMainCategories: [
          {
            value: "all",
            label: "All",
          },
          ..._data,
        ],
      }));
    } else {
      toast(err, { type: "error" });
    }
    setMainCategoriesStates((prev) => ({ ...prev, loader: false }));
  };

  const [brandStates, setBrandStates] = useState<{
    loader: boolean;
    searchVal: string;
    isSearch: boolean;
    allBrands: { value: string; label: string }[];
  }>({
    loader: false,
    searchVal: "",
    isSearch: false,
    allBrands: [],
  });
  const fetchBrands = async () => {
    setBrandStates((prev) => ({ ...prev, loader: true }));
    const { res, err } = await httpRequest<{
      documents: { _id: string; brandName: string }[];
    }>({ path: "/brand/home/getallbrands" });
    if (res) {
      const _data = (res?.documents || [])?.map((v) => ({
        value: v?._id,
        label: v?.brandName,
      }));
      setBrandStates((prev) => ({
        ...prev,
        allBrands: [
          {
            value: "all",
            label: "All",
          },
          ..._data,
        ],
      }));
    } else {
      toast(err, { type: "error" });
    }
    setBrandStates((prev) => ({ ...prev, loader: false }));
  };

  useEffect(() => {
    fetchProducts();
  }, [queryParams]);

  useEffect(() => {
    fetchMainCategories();
    fetchBrands();
  }, []);

  const BackButton: React.FC = () => {
    return (
      <Link
        to={`/doctor/appointment/${appointmentId}/prescribe?type=pharmacy`}
        className="right-bar-icon"
      >
        <img src={BackIcon} alt="back-icon" />
      </Link>
    );
  };

  return (
    <>
      <AddProductPrescribeModal
        appointmentId={appointmentId}
        productId={prescribeProductId}
        productName={
          products?.find((v) => v._id === prescribeProductId)?.productName || ""
        }
        type="pharmacy"
        show={prescribeProductId ? true : false}
        onClose={() => setPrescribeProductId(null)}
      />
      <div className="view-area-width-2 h-3vw">
        {/* <div className="container-1480 h-3vw"> */}
        <PageHeader
          title={isPrescribe ? "Prescribe" : "Pharmacy"}
          {...(isPrescribe
            ? { isButton: true, ButtonComponent: BackButton }
            : {})}
        />
        {isLoader && <SplashScreen />}
        <div className="dasboard-new-filter">
          <div
            id={"pharma-dasboard-bg-tem-height"}
            className="pharma-dasboard-bg-tem"
          >
            <div className="flex justify-between items-center gap-2 mt-3.5">
              <div className="flex items-center gap-2 flex-1">
                <CustomWebsiteDropdown
                  options={mainCategoriesStates?.allMainCategories}
                  setData={(data) => {
                    if (data.length > 0) {
                      setQueryParams((prev) => ({
                        ...prev,
                        mainCategoryId: data?.map((v) => v?.value),
                      }));
                    } else {
                      setQueryParams((prev) => ({
                        ...prev,
                        mainCategoryId: ["all"],
                      }));
                    }
                  }}
                  data={
                    mainCategoriesStates?.allMainCategories?.filter((v) =>
                      queryParams?.mainCategoryId?.includes(v?.value)
                    ) || []
                  }
                  placeholder="Filter by Category"
                  withoutMargin
                  loading={mainCategoriesStates?.loader}
                  mainDivClass="min-w-[130px] lg:min-w-[12vw] !w-fit"
                  showRadioBtn
                />
                <CustomWebsiteDropdown
                  options={brandStates?.allBrands}
                  setData={(data) => {
                    if (data.length > 0) {
                      setQueryParams((prev) => ({
                        ...prev,
                        brandId: data?.map((v) => v?.value),
                      }));
                    } else {
                      setQueryParams((prev) => ({
                        ...prev,
                        brandId: ["all"],
                      }));
                    }
                  }}
                  data={
                    brandStates?.allBrands?.filter((v) =>
                      queryParams?.brandId?.includes(v?.value)
                    ) || []
                  }
                  placeholder="Filter by Brand"
                  withoutMargin
                  loading={brandStates?.loader}
                  mainDivClass="min-w-[130px] lg:min-w-[12vw] !w-fit"
                  showRadioBtn
                />
                <PriceFilterDropdown
                  setData={(data) => {
                    if (data) {
                      setQueryParams((prev) => ({
                        ...prev,
                        minPrice: data?.min || "",
                        maxPrice: data?.max || "",
                      }));
                    } else {
                      setQueryParams((prev) => ({
                        ...prev,
                        minPrice: "",
                        maxPrice: "",
                      }));
                    }
                  }}
                  data={
                    queryParams?.minPrice !== "" || queryParams?.maxPrice !== ""
                      ? {
                          min: queryParams?.minPrice,
                          max: queryParams?.maxPrice,
                        }
                      : null
                  }
                  placeholder="Filter by Price"
                  withoutMargin
                  mainDivClass="min-w-[130px] lg:min-w-[12vw] !w-fit"
                />
              </div>
              <SearchFilterInput
                placeHolder="Search for Products"
                searchVal={queryParams?.search || ""}
                onChangeText={(val) =>
                  setQueryParams((prev) => ({
                    ...prev,
                    search: val || "",
                  }))
                }
                inputExtraStyle={{
                  marginBottom: "0",
                }}
              />
            </div>
            <hr className="my-3 xs:my-4 products-tabs-hr-allOrder" />
            <div
              key={`${Math.random()}${queryParams?.brandId?.length}${
                queryParams?.mainCategoryId?.length
              }`}
              className="diagnostic-products-grid"
            >
              {products.map((item) => (
                <div key={item?._id} className="pharmacy-card-main">
                  {/* <div className="Prescription-requird-main">
                    <div className="Prescription-requird">
                      {item?.prescriptionRequired ? (
                        <span className="Prescription-requird-inner-span text-white font-Poppins-Regular font-size-12px">
                          Prescription Required
                        </span>
                      ) : (
                        <span></span>
                      )}
                      {!isPrescribe && (
                        <IsFavoriteComponent
                          productId={item?._id}
                          isFav={item?.isLiked || false}
                          category="pharmacy"
                          onSuccess={handleIsLikeChanged}
                        />
                      )}
                    </div>
                  </div> */}
                  <div className="pharmacy-card-main-content-cls-inner w-full aspect-[1/0.8]">
                    <img
                      className="w-full h-full object-contain"
                      src={`${item?.mainImage}`}
                      alt={""}
                    />
                  </div>
                  <div className="pharmacy-card-main-content-cls min-h-[100px] lg:min-h-[8vw] flex flex-col justify-between">
                    <div>
                      {isPrescribe ? (
                        <span>
                          <p className="font-size-18px line-clamp-2 font-Poppins-SemiBold theme-color-green">
                            {item?.productName}
                          </p>
                        </span>
                      ) : (
                        <Link
                          to={`/customer/pharmacy-product-detail/${item?._id}/view`}
                        >
                          <p className="font-size-18px line-clamp-2 font-Poppins-SemiBold theme-color-green">
                            {item?.productName}
                          </p>
                        </Link>
                      )}
                      {item?.quantity === 0 && (
                        <p className="font-size-14px text-[#ff0000] gap-1 font-Poppins-Regular flex justify-end items-center">
                          <FontAwesomeIcon icon={faInfoCircle} /> Out of Stock
                        </p>
                      )}
                    </div>
                    <div className="flex product-item-card-price justify-between">
                      <div className="sale-price-or-regular-price">
                        <span className="font-size-22px font-Poppins-Bold theme-color-green">
                          {CURRENCY} {parseFloat(item?.salePrice?.toString() || item?.regularPrice?.toString() || "0").toLocaleString()}
                        </span>
                        {item?.salePrice != null && item?.salePrice > 0 && (
                          <span className="font-size-16px line-through font-Poppins-Medium font-Poppins-Regular text-[#878787]">
                            {CURRENCY} {`${item?.regularPrice?.toLocaleString() || "-"}`}
                          </span>
                        )}
                      </div>
                      <button
                        onClick={() => setPrescribeProductId(item?._id)}
                        className="add-to-cart-products"
                      >
                        <FontAwesomeIcon
                          size="sm"
                          className="text-white"
                          icon={faPlus}
                        />
                      </button>
                      {/* {isPrescribe ? (
                        <button
                          onClick={() => setPrescribeProductId(item?._id)}
                          className="add-to-cart-products"
                        >
                          <FontAwesomeIcon
                            size="sm"
                            className="text-white"
                            icon={faPlus}
                          />
                        </button>
                      ) : (
                        <AddCartComponent
                          productId={item?._id}
                          type="pharmacy"
                          stockQuantity={item?.quantity}
                          prescriptionRequired={
                            item?.prescriptionRequired || false
                          }
                          quantity={1}
                        />
                      )} */}
                    </div>
                  </div>
                </div>
              ))}
            </div>
            <PaginationComponet
              currentPage={paginated.currentPage || 1}
              total={paginated.totalPages || 1}
              setCurrentPage={(_page) =>
                setQueryParams((prev) => ({ ...prev, page: _page }))
              }
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default DashboardPharmacyProducts;
